import ApproveExpense from "./ApproveExpense";

export default ApproveExpense;
